import { createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, resolveComponent as _resolveComponent, createVNode as _createVNode, toDisplayString as _toDisplayString, withModifiers as _withModifiers, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "plan-content" }
const _hoisted_2 = { class: "container-fluid" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-md-6" }
const _hoisted_5 = { class: "row" }
const _hoisted_6 = { class: "col-12" }
const _hoisted_7 = { class: "text-input" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("label", {
  for: "zip",
  class: "body-text"
}, "Postal/Zip Code", -1)
const _hoisted_9 = { class: "row mt-20" }
const _hoisted_10 = { class: "col-12" }
const _hoisted_11 = /*#__PURE__*/_createElementVNode("small", null, "IATSE NBF Accepts VISA or Mastercard", -1)
const _hoisted_12 = { class: "row mt-20" }
const _hoisted_13 = { class: "col-12" }
const _hoisted_14 = { class: "text-input" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("label", {
  for: "cardholderFirstName",
  class: "body-text"
}, "Cardholder's First Name", -1)
const _hoisted_16 = { class: "row mt-20" }
const _hoisted_17 = { class: "col-12" }
const _hoisted_18 = { class: "text-input" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("label", {
  for: "cardholderLastName",
  class: "body-text"
}, "Cardholder's Last Name", -1)
const _hoisted_20 = { class: "row mt-20" }
const _hoisted_21 = { class: "col-12" }
const _hoisted_22 = { class: "row mt-20" }
const _hoisted_23 = { class: "col-6" }
const _hoisted_24 = { class: "col-6" }
const _hoisted_25 = { class: "text-input" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("label", {
  for: "",
  class: "body-text"
}, "CVV", -1)
const _hoisted_27 = { class: "col-md-6" }
const _hoisted_28 = { class: "capp-summary" }
const _hoisted_29 = { class: "capp-summary__option" }
const _hoisted_30 = /*#__PURE__*/_createElementVNode("small", null, "Selected Coverage", -1)
const _hoisted_31 = { class: "capp-summary__content" }
const _hoisted_32 = { class: "amount-owed" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("p", null, "Amount owed", -1)
const _hoisted_34 = { class: "capp-summary__action mt-10" }
const _hoisted_35 = { class: "row mt-20" }
const _hoisted_36 = { class: "col-md-12" }
const _hoisted_37 = { class: "d-flex w-100 justify-content-between" }
const _hoisted_38 = /*#__PURE__*/_createElementVNode("button", {
  type: "submit",
  class: "btn btn-primary"
}, "Submit", -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_SelectComponent = _resolveComponent("SelectComponent")!
  const _component_CardNumberField = _resolveComponent("CardNumberField")!
  const _component_CardExpirationField = _resolveComponent("CardExpirationField")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("form", {
        onSubmit: _cache[9] || (_cache[9] = _withModifiers(
//@ts-ignore
(...args) => ($setup.payCapp && $setup.payCapp(...args)), ["prevent"]))
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "zip",
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => (($setup.zip) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.zip]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_9, [
              _createElementVNode("div", _hoisted_10, [
                _createVNode(_component_SelectComponent, {
                  label: "Card Type",
                  modelValue: $setup.cardType,
                  "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (($setup.cardType) = $event)),
                  options: $setup.cardOptions
                }, null, 8, ["modelValue", "options"]),
                _hoisted_11
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("div", _hoisted_14, [
                  _hoisted_15,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "cardholderFirstName",
                    "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (($setup.cardholderFirstName) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cardholderFirstName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_16, [
              _createElementVNode("div", _hoisted_17, [
                _createElementVNode("div", _hoisted_18, [
                  _hoisted_19,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "cardholderLastName",
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (($setup.cardholderLastName) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cardholderLastName]
                  ])
                ])
              ])
            ]),
            _createElementVNode("div", _hoisted_20, [
              _createElementVNode("div", _hoisted_21, [
                _createVNode(_component_CardNumberField, {
                  modelValue: $setup.cardNumber,
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (($setup.cardNumber) = $event))
                }, null, 8, ["modelValue"])
              ])
            ]),
            _createElementVNode("div", _hoisted_22, [
              _createElementVNode("div", _hoisted_23, [
                _createVNode(_component_CardExpirationField, {
                  modelValue: $setup.cardExpiration,
                  "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => (($setup.cardExpiration) = $event))
                }, null, 8, ["modelValue"])
              ]),
              _createElementVNode("div", _hoisted_24, [
                _createElementVNode("div", _hoisted_25, [
                  _hoisted_26,
                  _withDirectives(_createElementVNode("input", {
                    type: "text",
                    id: "",
                    name: "text-group",
                    placeholder: "Add CVV",
                    maxlength: "",
                    "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (($setup.cvv) = $event)),
                    class: "links"
                  }, null, 512), [
                    [_vModelText, $setup.cvv]
                  ])
                ])
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_27, [
            _createElementVNode("div", _hoisted_28, [
              _createElementVNode("div", _hoisted_29, [
                _hoisted_30,
                _createElementVNode("h4", null, _toDisplayString($setup.selectedInvoice?.Title || 'No coverage selected'), 1)
              ]),
              _createElementVNode("div", _hoisted_31, [
                _createElementVNode("div", _hoisted_32, [
                  _hoisted_33,
                  _createElementVNode("h4", null, _toDisplayString($setup.formatCurrency($setup.selectedInvoice?.AmountOwed) || '$0.00'), 1)
                ])
              ]),
              _createElementVNode("div", _hoisted_34, [
                _createElementVNode("a", {
                  href: "#",
                  class: "btn btn-primary w-100",
                  onClick: _cache[7] || (_cache[7] = _withModifiers(($event: any) => ($setup.openModal('hw-capp-statement', 'Invoices', 'plan-upload plan-card-info plan-c-mrp-claims')), ["prevent"]))
                }, "Change Above Selection")
              ])
            ])
          ])
        ]),
        _createElementVNode("div", _hoisted_35, [
          _createElementVNode("div", _hoisted_36, [
            _createElementVNode("div", _hoisted_37, [
              _createElementVNode("button", {
                onClick: _cache[8] || (_cache[8] = _withModifiers(($event: any) => ($setup.goBack()), ["prevent"])),
                class: "btn btn-tertiary"
              }, "Cancel"),
              _hoisted_38
            ])
          ])
        ])
      ], 32)
    ])
  ]))
}